import { useQuery } from "@tanstack/react-query";
import { onboardingApi } from "../api/onboardingApi";

export function useOnboardingStatusQuery() {
  return useQuery({ queryKey: ["onboarding", "status"], queryFn: onboardingApi.getStatus });
}
